import domEnums from 'app/dom_mutators/enums';
/*
 * @func showCustomMinimizedButton
 *
 * @description
 * if customer has rendered their own custom minimized button
 * decorate it with the show class
 *
 * @returns {Boolean} - indicates the presence of a custom button
 */
export default function showCustomMinimizedButton(hasAuthenticated) {
  const customButton = document.getElementById(domEnums.CUSTOM_BUTTON_ID);

  if (!customButton) {
    return false;
  }

  hasAuthenticated
    ? customButton.classList.add(domEnums.HAS_AUTHENTICATED)
    : customButton.classList.remove(domEnums.HAS_AUTHENTICATED);
  customButton.classList.add(domEnums.SHOW_CUSTOM_BUTTON);

  return true;
}
